import React from 'react';
import { motion } from 'framer-motion';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function BehindTheVision() {
  return <section className="py-16 px-4 bg-gray-50" data-id="element-226">
      <div className="max-w-3xl mx-auto" data-id="element-227">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true
      }} variants={fadeIn} data-id="element-228">
          <h2 className="text-2xl sm:text-3xl font-bold text-[#0f1f3d] mb-8 text-center" data-id="element-229">
            Behind the Vision
          </h2>

          <div className="prose prose-lg text-gray-600 mx-auto space-y-6 leading-relaxed" data-id="element-230">
            <p data-id="element-231">
              Master Joe Whitworth was born in South Korea. He lived in an
              orphanage until the age of 10, when he was adopted by his
              American, English-speaking family. When he started elementary
              school, as a foreigner he was taunted and bullied by other kids,
              so shortly after he arrived in the United States he started
              learning Taekwondo at a local school. Martial arts gave him the
              confidence he needed to assert himself.
            </p>
            <p data-id="element-232">
              Master Joe Whitworth has been an athlete for his entire life. He
              competed in a variety of sports, but it was through Taekwondo that
              he found his stride and purpose. He has instructed Taekwondo for
              over 20 years. A few years ago through a series of twists and
              turns he made the commitment to himself, his family and his future
              students that he would open his own school, focusing on the things
              that students, parents and athletes were searching for in a
              Taekwondo education.
            </p>
            <p data-id="element-233">
              At present Master Joe is a 5th degree black belt and has 25 years
              of experience in teaching martial arts. Master Joe expects a lot
              from his students. He encourages his students to work hard at
              martial arts and in school. Students look to Master Joe for
              instruction on technique, for a lesson in life, for a good laugh
              after class, and for inspiration when times are tough.
            </p>
            <p className="font-semibold text-[#0f1f3d]" data-id="element-234">
              Learning the skill of martial arts has helped Master Joe grow into
              a successful and confident man. He wants to pass on and instill
              these skills in his students. Master Joe and his instructors give
              their students a little piece of themselves during each and every
              class.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}